import { Box, Center } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import { take } from 'lodash';
import PeOffersShortGrid from 'presentation/components/modules/pe/shared/grid/shortGrid/PeOffersShortGrid';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchHomeQuery } from 'rtkQuery/sharespro/queries/home';

const HomePeCompanyOffersContainer: FC = () => {
  const { t } = useTranslation();

  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch } = useFetchHomeQuery({
    period,
    account_id: accountId,
  });

  const navigate = useNavigate();

  const wrapByCard = !data;
  let content;
  if (data && data.peSharesproOrders.length > 0) {
    content = (
      <PeOffersShortGrid
        orders={take(data.peSharesproOrders, 3).map((order) => ({
          id: order.id,
          name: order.company.name,
          subtitle1: order.subtitle1,
          subtitle2: order.subtitle2,
          tags: order.company.tags,
          color: order.company.color,
          gradientColor: order.company.gradientColor,
          companyLogo: order.company.logoSrc,
        }))}
        onCardClick={(id: ID) => navigate(AppRoute.peCompanyOrderDetail(id))}
      />
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  if (!content) {
    return null;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <Box mb="20px">
      <GridHeading
        trailingLink={{
          text: t('allItems'),
          path: AppRoute.peOffers,
        }}
      >
        {t('sharesproOffers')}
      </GridHeading>
      {content}
    </Box>
  );
};

export default HomePeCompanyOffersContainer;
